import { Moon, Sun } from "lucide-react";
import { usePrefs } from "../../context/PrefsContext";
import { NeuButton } from "../neu/Neu";
import { FlagUAE, FlagUK } from "./FlagIcon";

// Same box size as the notification bell; the flag shown is the language you switch to.
export const LangToggle = () => {
  const { lang, setLang } = usePrefs();
  const next = lang === "ar" ? "en" : "ar";
  return (
    <button
      type="button"
      data-testid="lang-toggle"
      aria-label={next === "en" ? "Switch to English" : "التبديل إلى العربية"}
      title={next === "en" ? "English" : "العربية"}
      onClick={() => setLang(next)}
      className="flex h-12 w-12 items-center justify-center rounded-2xl shadow-neu-sm transition-[box-shadow] duration-300 hover:shadow-neu-in"
    >
      {next === "en" ? <FlagUK className="h-[17px] w-[34px] rounded-[2px]" /> : <FlagUAE className="h-[17px] w-[34px] rounded-[2px]" />}
    </button>
  );
};

export const ThemeToggle = () => {
  const { theme, toggleTheme } = usePrefs();
  return (
    <NeuButton data-testid="theme-toggle" aria-label="Toggle theme" className="px-4 py-2" onClick={toggleTheme}>
      {theme === "dark" ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />}
    </NeuButton>
  );
};
